module.exports = __webpack_public_path__ + "img/1557614067924934658.8cfbf0dc.png";